<div class="credit-card" [class]="statusClass">
  <div class="card-header">
    <div class="header-info">
      <i class="pi pi-building"></i>
      <h3>Información de la Empresa</h3>
    </div>
    <div class="completion-indicator">
      <span class="percentage">{{ completionPercentage }}%</span>
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="completionPercentage"></div>
      </div>
    </div>
  </div>

  <div class="card-content">
    <div *ngIf="!hasData" class="no-data">
      <i class="pi pi-building"></i>
      <p>No hay información de la empresa disponible</p>
    </div>

    <div *ngIf="hasData" class="data-sections">
      <div class="section">
        <h4 class="section-title">Datos de la Empresa</h4>
        <div class="data-grid">
          <div class="data-item featured" *ngIf="data?.companyName">
            <label>Razón Social:</label>
            <span class="value">{{ data?.companyName }}</span>
          </div>

          <div class="data-item" [class.empty]="!data?.rfc">
            <label>RFC:</label>
            <span [class]="data?.rfc ? 'value' : 'placeholder'">
              {{ data?.rfc || 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!representativeName || representativeName === 'No especificado'">
            <label>Representante Legal:</label>
            <span [class]="representativeName !== 'No especificado' ? 'value' : 'placeholder'">
              {{ representativeName }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.clientType">
            <label>Tipo de Cliente:</label>
            <span [class]="data?.clientType ? 'value' : 'placeholder'">
              {{ data?.clientType || 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.nationality">
            <label>Nacionalidad:</label>
            <span [class]="data?.nationality ? 'value' : 'placeholder'">
              {{ data?.nationality || 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.portfolioRating">
            <label>Calificación de Cartera:</label>
            <span [class]="data?.portfolioRating ? 'value' : 'placeholder'">
              {{ data?.portfolioRating || 'No especificado' }}
            </span>
          </div>
        </div>
      </div>

      <div class="section">
        <h4 class="section-title">Información de Contacto</h4>
        <div class="data-grid">
          <div class="data-item featured" *ngIf="fullAddress !== 'No especificado'">
            <label>Dirección:</label>
            <span class="value address-full">{{ fullAddress }}</span>
          </div>

          <div class="data-item" [class.empty]="!data?.phone">
            <label>Teléfono:</label>
            <span [class]="data?.phone ? 'value' : 'placeholder'">
              {{ formatPhone(data?.phone) }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.email">
            <label>Email:</label>
            <span [class]="data?.email ? 'value' : 'placeholder'">
              {{ data?.email || 'No especificado' }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
